// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"StampTax_calTitleCustom__XwZxS"};